.sell-experience-navigation-bar .sell-experience-navigation-desktop-only {
  display: none;
}

.sell-experience-navigation-bar .sell-experience-navigation-mobile-only {
  display: flex;
}

.sell-experience-mobile-menu-icon-line {
  transition:
    d 300ms cubic-bezier(0.55, 0, 0.15, 1),
    transform 300ms cubic-bezier(0.55, 0, 0.15, 1);
}

.sell-experience-mobile-drawer {
  transition: transform 500ms ease-out;
  transform: translateX(0);
}

/* BaseUI marks the panel with these attributes while it animates in/out. */
.sell-experience-mobile-drawer[data-starting-style],
.sell-experience-mobile-drawer[data-ending-style] {
  transform: translateX(100%);
}

@media (min-width: 768px) {
  .sell-experience-navigation-bar .sell-experience-navigation-desktop-only {
    display: flex;
  }

  .sell-experience-navigation-bar .sell-experience-navigation-mobile-only {
    display: none;
  }
}
